import { inferLiteral } from "client/utils"
import * as types from "./types"

export const setAccountSettings = (settings: types.AccountSettings) => ({
    type: inferLiteral(types.SET_ACCOUNT_SETTINGS),
    settings,
})

export const updateAccountSettings = (
    section: keyof types.AccountSettings,
    settings: types.ChangeAccountSettings,
) => ({
    type: inferLiteral(types.UPDATE_ACCOUNT_SETTINGS),
    data: { section, settings },
})
